import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import DropzoneCooperatedFiles from "components/dropzoneCooperatedFiles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import { useState } from "react";
import MDTypography from "components/MDTypography";

const CooperatedFormDocs = ({
  label,
  identificationDocument,
  setIdentificationDocument,
  maritalStatus,
  setMaritalStatus,
  addressProof,
  setAddressProof,
  incomeProof,
  setIncomeProof,
  subscriptionCard,
  setSubscriptionCard,
}) => {
  const [step, setStep] = useState(false);

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox lineHeight={0}>
              <MDTypography variant="h5">Documentos</MDTypography>

              <MDBox
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="button" color="title">
                  <MDTypography variant="button" color="text">
                    <strong>Tamanho max. para arquivo: </strong>
                  </MDTypography>
                  1 MB <strong style={{ color: "red" }}>*</strong>
                </MDTypography>

                <MDTypography variant="button" color="title">
                  <span>
                    <MDTypography variant="button" color="text">
                      <strong>Tipos de arquivos: </strong>
                    </MDTypography>
                    .png, .jpg, .jpeg, .pdf
                  </span>
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox mt={1.625}>
              {/* Documento de Identificação */}
              <DropzoneCooperatedFiles
                onChange={(e) => {
                  setIdentificationDocument([
                    ...identificationDocument,
                    e.target.files[0],
                  ]);
                }}
                label="Adicionar Frente e Verso do Documento de Identificação"
                files={identificationDocument}
                setFiles={setIdentificationDocument}
                required
              />

              {/* Comprovante Estado Civil */}
              <DropzoneCooperatedFiles
                onChange={(e) => {
                  setMaritalStatus([...maritalStatus, e.target.files[0]]);
                }}
                label="Adicionar Comprovante Estado Civil"
                files={maritalStatus}
                setFiles={setMaritalStatus}
              />

              {/* Comprovante de Residência */}
              <DropzoneCooperatedFiles
                onChange={(e) => {
                  setAddressProof([...addressProof, e.target.files[0]]);
                }}
                label="Adicionar Comprovante de Residência"
                files={addressProof}
                setFiles={setAddressProof}
                required
              />

              {/* Comprovante de Renda */}
              <DropzoneCooperatedFiles
                onChange={(e) => {
                  setIncomeProof([...incomeProof, e.target.files[0]]);
                }}
                label="Adicionar Comprovante de Renda"
                files={incomeProof}
                setFiles={setIncomeProof}
                required
              />

              {/* Ficha de Interesse */}
              <DropzoneCooperatedFiles
                onChange={(e) => {
                  setSubscriptionCard([...subscriptionCard, e.target.files[0]]);
                }}
                label="Adicionar Ficha de Interesse"
                files={subscriptionCard}
                setFiles={setSubscriptionCard}
                required
              />
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormDocs;
